import i18n from "i18next";
import { logError } from "src/errorHandling/errorLogging.ts";

export function localizeUnsafe(key: string): string {
	if (!i18n.exists(key)) {
		logError(`Localization key not found: ${key}`);
	}
	return i18n.t(key as any);
}
